import type { QuarantineStats } from '$db/local/repositories/quarantine.repo';

const STORAGE_KEY = 'sq:quarantineAcknowledgedCount';

/**
 * Store reactivo del estado visible de la cuarentena (M4.6).
 *
 * - `count` y `bytes` se sincronizan vía liveSync desde App.svelte
 *   (Dexie liveQuery en la tabla quarantine).
 * - `acknowledgedCount` se persiste en localStorage: cuántas ops había
 *   la última vez que el usuario abrió el panel.
 * - `hasNew` = hay contenido sin revisar (dispara el banner).
 * - `hasAny` = hay contenido (dispara el badge en el botón).
 */
class QuarantineStore {
  count = $state(0);
  bytes = $state(0);
  acknowledgedCount = $state(0);
  loaded = $state(false);

  get hasNew(): boolean {
    return this.count > this.acknowledgedCount;
  }

  get hasAny(): boolean {
    return this.count > 0;
  }

  load(): void {
    if (this.loaded) return;
    if (typeof localStorage === 'undefined') {
      this.loaded = true;
      return;
    }
    const raw = localStorage.getItem(STORAGE_KEY);
    const n = raw !== null ? Number.parseInt(raw, 10) : 0;
    this.acknowledgedCount = Number.isFinite(n) && n >= 0 ? n : 0;
    this.loaded = true;
  }

  update(stats: QuarantineStats): void {
    this.count = stats.count;
    this.bytes = stats.bytes;
    // Si la cuarentena bajó por debajo del acknowledged, ajustar para no
    // quedar "negativo" (por ejemplo si el usuario borró todo desde otra tab).
    if (this.acknowledgedCount > this.count) {
      this.acknowledgedCount = this.count;
      this.persistAcknowledged();
    }
  }

  acknowledge(): void {
    this.acknowledgedCount = this.count;
    this.persistAcknowledged();
  }

  private persistAcknowledged(): void {
    if (typeof localStorage === 'undefined') return;
    try {
      localStorage.setItem(STORAGE_KEY, String(this.acknowledgedCount));
    } catch {
      // localStorage puede fallar en modo privado: no es crítico.
    }
  }
}

export const quarantineStore = new QuarantineStore();